import type { ClientSummaryRef } from '../api/types';

/** Business accounts display the company name; residential accounts the person's name. */
export function clientLabel(client: ClientSummaryRef): string {
  if (client.businessName) return client.businessName;
  return [client.firstName, client.middleName, client.lastName].filter(Boolean).join(' ').trim();
}
